import type { NavMenuItemConfig } from '@zto/zpage'

export const menus: NavMenuItemConfig[] = [
  {
    name: 'default',
    children: [
      {
        name: 'welcome',
        children: [
          {
            title: '数据简报',
            name: 'app.portal.data-bulletin.manager',
            path: '/portal/data-bulletin/manager'
          },
          {
            title: '审批列表',
            name: 'app.portal.tasks',
            path: '/portal/tasks'
          },
          {
            title: '资讯列表',
            name: 'app.portal.news',
            path: '/portal/news'
          },
          {
            title: '问答列表',
            name: 'app.portal.qa',
            path: '/portal/qa'
          },
          {
            title: '详情',
            name: 'app.portal.detail',
            path: '/portal/detail'
          },
          {
            title: '搜索结果',
            name: 'app.portal.searchResult',
            path: '/portal/searchResult'
          },
          {
            title: '系统公告',
            name: 'app.portal.message',
            path: '/portal/message'
          },
          {
            title: '审核详情',
            name: 'app.operate.audit.detail',
            path: '/operate/audit/detail'
          }
        ]
      }
    ]
  },
  {
    name: 'kt.operate',
    isAuth: true,
    children: [
      {
        name: 'kt.operate.task',
        isAuth: true,
        children: [
          {
            isAuth: true,
            name: 'kt.operate.task.workorder.normal',
            children: [
              {
                name: 'kt.operate.task.workorder.add',
                path: '/operate/task/workorder/add',
                title: '新增工单',
                meta: {
                  isTemp: true,
                  hidden: true
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    name: 'kt.finance',
    isAuth: true,
    children: [
      {
        name: 'kt.finance.base',
        isAuth: true,
        children: [
          {
            name: 'kt.finance.base.accountSubjects',
            title: '账户主体',
            path: '/finance/base/accountSubjects'
          }
        ]
      },
      {
        name: 'kt.finance.bill',
        isAuth: true,
        children: [
          {
            name: 'kt.finance.bill.balances',
            title: '账户余额',
            path: '/finance/bill/balances'
          },
          {
            name: 'kt.finance.bill.balanceChanges',
            title: '账户余额变化',
            path: '/finance/bill/balanceChanges'
          },
          {
            name: 'kt.finance.bill.settlements',
            title: '账户结算明细',
            path: '/finance/bill/settlements'
          }
        ]
      },
      {
        name: 'kt.finance.operate',
        isAuth: true,
        children: [
          {
            name: 'kt.finance.operate.settlementAudits',
            title: '账户结算审核',
            path: '/finance/operate/settlementAudits'
          }
        ]
      },
      {
        name: 'kt.finance.mechanismReceipt',
        isAuth: true,
        children: [
          {
            name: 'kt.finance.mechanismReceipt.organization',
            title: '机构回单明细',
            path: '/finance/mechanismReceipt/organization'
          },
          {
            name: 'kt.finance.mechanismReceipt.baiwang',
            title: '百望推票明细',
            path: '/finance/mechanismReceipt/baiwang'
          }
        ]
      },
      {
        name: 'kt.finance.transaction',
        isAuth: true,
        children: [
          {
            name: 'kt.finance.transaction.organizeTransaction',
            title: '机构交易查询',
            path: '/finance/transaction/organizeTransaction'
          }
        ]
      }
    ]
  }
]
